<template>
    <div class="page--crud">
        <div>
            <h3 class="title">Relatório de vendas do Zepplin</h3>
            <app-zepplin-request-report-filter ref="filter" :loading="loading" @clean-selection="selectedItems = []" @search="search($event)"></app-zepplin-request-report-filter>
            <app-grid ref="grid" v-model="selectedItems" :columns="columns" :rows="rows" :total="totalItems" :loading="loading">
                <div class="summary" style="display: flex; justify-content: space-between; align-items: center">
                    <div style="display: flex;">
                        <div class="summary__item">
                            <span>Itens</span>
                            <h3>{{ totalItems }}</h3>
                        </div>
                        <div class="summary__item">
                            <span>Líq. acum.</span>
                            <h3>{{ utils.formatMoney(totalSubtotal,2,'R$ ','.',',') }}</h3>
                        </div>
                        <div class="summary__item">
                            <span>Saldo acum.</span>
                            <h3>{{ utils.formatMoney(totalAmount,2,'R$ ','.',',') }}</h3>
                        </div>
                        <div class="summary__item">
                            <span>Taxa pagamento acum.</span>
                            <h3>{{ utils.formatMoney(totalCreditCardTax,2,'R$ ','.',',') }}</h3>
                        </div>
                        <div class="summary__item">
                            <span>Taxa acum.</span>
                            <h3>{{ utils.formatMoney(totalZepplinTax,2,'R$ ','.',',') }}</h3>
                        </div>
                    </div>
                    <div>
                        <app-pagination :currentPage="currentPage" :totalPages="getTotalPages" @pagechanged="onPageChange"></app-pagination>
                    </div>
                    <div style="display: flex">
                        <div class="summary__item border-left">
                            <span>Selecionados</span>
                            <h3>{{ selectedItems.length }}</h3>
                        </div>
                        <div class="summary__item border-left">
                            <span>Taxa pag. online</span>
                            <h3>{{ utils.formatMoney(selectedItemsTotalCreditCardTax, 2,'R$ ','.',',') }}</h3>
                        </div>
                        <div class="summary__item border-left">
                            <span>Taxa</span>
                            <h3>{{ utils.formatMoney(selectedItemsTotalZepplinTax, 2,'R$ ','.',',') }}</h3>
                        </div>
                        <div class="summary__item border-left">
                            <span>Bruto</span>
                            <h3>{{ utils.formatMoney(selectedItemsTotalAmount, 2,'R$ ','.',',') }}</h3>
                        </div>
                        <div class="summary__item" style="flex-direction: row; align-items: flex-start">
                            <span style="margin-right: 10px;">Líquido</span>
                            <h3 style="color: var(--font-color--8); font-weight: 400; font-size: 28px; align-self: center;">{{ utils.formatMoney(selectedItemsTotalSubtotal, 2,'R$ ','.',',') }}</h3>
                        </div>
                    </div>
                </div>
                <template slot="actions" slot-scope="slotProps">
                    <a href="javascript:void(0)" class="edit-row" @click.stop="recover(slotProps.row.id)">
                        <icon-edit></icon-edit>
                    </a>
                </template>
            </app-grid>

            <div class="footer">
                <!-- <div class="left-side" style="padding-left: 0;">
                    <img :src="logoSrc" style="margin-left: 0" />
                </div>
                <span class="push-both-sides"></span> -->
                <!-- <div class="right-side" v-if="actionsSelectItems.length >= 1">
                    <div class="group">
                        <span>Com selecionados:</span>
                        <app-select v-model="form.action" :items="actionsSelectItems" :popoverProps="{placement:'top-start', horizontalOffset: -15}" title="Ação">
                            <a href="javascript:void(0)" v-if="!form.action">-- Selecione --</a>
                            <a href="javascript:void(0)" v-else>{{ _.find(actionsSelectItems, {value: form.action}).text }}</a>
                            <template slot="section" slot-scope="sectionProps">
                                <h3 style="text-align: left;">{{ sectionProps.text }}</h3>
                            </template>
                            <template slot="item" slot-scope="itemProps">
                                <span>{{itemProps.text }}</span>
                            </template>
                        </app-select>
                    </div>
                    <div class="group">
                        <span>No horário:</span>
                        <app-datetime-selector class="input--borderless datetime-selector" v-model="form.markDatetime" :config="datetimeSelectorConfig" placeholder="HORÁRIO ATUAL"></app-datetime-selector>
                        <a href="javascript:void(0)" v-if="form.markDatetime" @click="form.markDatetime = null"><icon-remove></icon-remove></a>
                    </div>
                    <a class="btn btn--primary" @click="submit()">Confirmar</a>
                </div> -->
            </div>
        </div>
    </div>
</template>
<script>
    import { mapGetters, mapState, mapActions } from 'vuex';

    import utils from '../../../../utils/index';
    import moment from 'moment';
    import _ from 'lodash';
    import shortid from 'shortid'

    import Request from '../../../../vuex/models/Request'

    import ZepplinRequestReportAPI from '../../../../api/zepplin-request-report'
    import RequestAPI from '../../../../api/requests'
    import ZepplinRequestReportComponent from './ZepplinRequestReportFilter.vue'
    import { GridCore } from '../../../../components/Utilities/Grid/index'
    import { Portuguese } from 'flatpickr/dist/l10n/pt'
    import PaginationComponent from '../../../../components/Utilities/Pagination.vue'

    export default {
        components: {
            'app-zepplin-request-report-filter': ZepplinRequestReportComponent,
            'app-grid': GridCore,
            'app-pagination': PaginationComponent
        },
        data(){
            return {
                logoSrc: require('../../../../assets/imgs/logo-2018.png'),
                filterData: [],
                currentPage: 1,
                offset: 0,
                limit: 50,
                totalItems: 0,
                totalAmount: 0,
                totalSubtotal: 0,
                totalZepplinTax: 0,
                totalCreditCardTax: 0,
                selectedItems: [],
                rows: [],
                columns: [
                    {
                        text: 'Nº',
                        name: 'id',
                        width: 80,
                        style: {
                            'justify-content': 'center'
                        }
                    },
                    {
                        text: 'Nome',
                        name: 'name'
                    },
                    {
                        text: 'Entrega feita por',
                        name: 'deliveryCompany'
                    },
                    {
                        text: 'Valor entrega',
                        name: 'deliveryTax',
                        width: 110
                    },
                    {
                        text: 'Data/Entrega',
                        name: 'deliveredDate',
                        width: 120
                    },
                    {
                        text: 'Pagamento',
                        name: 'paymentMethod',
                        width: 170
                    },
                    {
                        text: 'Taxa Pag. Online',
                        name: 'creditCardTax',
                        width:  170
                    },
                    {
                        text: 'Taxa',
                        name: 'zepplinTax',
                        width: 110
                    },
                    {
                        text: 'Cupom',
                        name: 'coupon',
                        width: 110
                    },
                    {
                        text: 'Bruto',
                        name: 'amount',
                        width: 120
                    },
                    {
                        text: 'Líquido',
                        name: 'subtotal',
                        width: 100
                    },
                    {
                        text: 'Ações',
                        name: 'actions',
                        style: {
                            'justify-content': 'center'
                        },
                        width: 72
                    }
                ],
                filterForm: {
                    deliveredDate: [[]],
                    deliveredDateToSend: [[]],
                    paymentMethod: [],
                    search: null
                },
                form: {
                    account: null,
                    action: 'received',
                    markDatetime: null,
                    deliveredDate: [[]],
                    deliveredDateToSend: [[]],
                    clientGroup: [],
                    paymentMethod: [],
                    responsibleUser: [],
                    status: []
                },
                loading: true,
                datetimeSelectorConfig: {
                    altInput: true,
                    altFormat: 'd/m/Y H:i:S',
                    dateFormat: 'Z',
                    locale: Portuguese,
                    time_24hr: true,
                    enableTime: true
                }
            }
        },
        computed: {
            ...mapState('auth',['company', 'user']),
            ...mapState('data/users',['users']),
            ...mapState('data/accounts',['accounts']),
            ...mapState('data/client-groups',['clientGroups']),
            ...mapState('data/payment-methods',['paymentMethods']),
            ...mapState('data/request-status',['requestStatusList']),
            ...mapGetters('data/request-status',['requestStatusListSelectItems']),
            selectedItemsTotalAmount(){
                const vm = this
                return _.sumBy(vm.selectedItems, (selectedItem) => {
                    console.log(selectedItem)
                    return parseFloat(selectedItem.payload.amount) + (selectedItem.payload.coupon ? parseFloat(selectedItem.payload.coupon.amount) : 0)
                })
            },
            selectedItemsTotalZepplinTax() {
                return _.sumBy(this.selectedItems, selectedItem => {
                    return parseFloat(selectedItem.payload.zepplinTax)
                })
            },
            selectedItemsTotalCreditCardTax() {
                return _.sumBy(this.selectedItems, selectedItem => {
                    return parseFloat(selectedItem.payload.creditCardTax)
                })
            },
            selectedItemsTotalSubtotal() {
                return _.sumBy(this.selectedItems, selectedItem => {
                    return parseFloat(selectedItem.payload.subtotal)
                })
            },
            accountsSelectItems(){
                return _.map(this.accounts, (account) => {
                    return {
                        value: account.id,
                        text: account.name
                    }
                })
            },
            getTotalPages() {
                return this.totalItems <= this.limit ? 
                    1 : 
                    (!Number.isInteger(this.totalItems / this.limit) ?
                        Math.trunc(this.totalItems / this.limit) : 
                        (this.totalItems / this.limit) - 1) + 1
            }
        },
        methods: {
            ...mapActions('draft/request',['runRequestRecoverance']),
            ...mapActions('toast',['showToast', 'showError']),
            async recover(requestId){
                const vm = this
                try {
                    // gambiarra
                    const request = await RequestAPI.getOne(requestId, { byZepplinId: true })
                    console.log(request.data)

                    const requestDenormalized = this.VXORM.STATE_Request.denormalizeRequest(request.data, request.data.status, false)
                    let STATE_request = this.VXORM.STATE_Request.query().where('requestId', requestId).first()

                    if(!STATE_request) {
                        const { STATE_requests } = await this.VXORM.STATE_Request.insert({ data: requestDenormalized })
                        STATE_request = STATE_requests[0]
                    }
                    STATE_request.openWindow(this)

                    STATE_request.$update({
                        where: STATE_request.id,
                        data: {
                            activeTab: 'order'
                        }
                    })
                }
                catch(err){
                    console.log("Error occurred", err)
                }
                /*this.runRequestRecoverance({ requestId, companyId: this.company.id })*/
            },
            search({ filterData = {}, params = {} } = {}){
                const vm = this
                this.loading = true
                this.filterData = filterData

                this.currentPage = 1
                this.offset = 0

                const requestParams = {
                    offset: vm.offset,
                    limit: vm.limit,
                    deliveredDate: this.filterData.deliveredDateToSend,
                    responsibleUser: this.filterData.responsibleUser,
                    status: this.filterData.status,
                    paymentMethodIds: this.filterData.paymentMethod,
                    search: this.filterData.search
                }
                this.updateFilter(requestParams)
            },
            submit(){
                const vm = this
                if(!vm.form.action){
                    vm.showToast({
                        type: 'error',
                        message: "Você deve selecionar uma ação!"
                    })
                    return
                }
                if(!vm.selectedItems.length){
                    vm.showToast({
                        type: 'error',
                        message: "Você não selecionou nenhum item!"
                    })
                    return
                }
            },
            onPageChange(page) {
                this.currentPage = page
                this.offset = parseInt(`${page-1}0`)
                let requestParams = {
                    limit: this.limit,
                    offset: this.offset * 5,
                    date: this.filterData.deliveredDateToSend,
                    responsibleUser: this.filterData.responsibleUser,
                    status: this.filterData.status,
                    search: this.filterData.search
                }
                this.updateFilter(requestParams)
            },
            updateFilter(requestParams) {
                const vm = this

                this.loading = true
                ZepplinRequestReportAPI.getList(requestParams).then(({data}) => {
                    vm.rows = _.map(data.requests.rows, vm.upsertRow)
                    this.totalItems = data.requests.count
                    this.totalAmount = data.total
                    this.totalSubtotal = data.subtotal
                    this.totalZepplinTax = data.requestTaxTotal
                    this.totalCreditCardTax = data.creditCardTaxTotal
                    this.loading = false
                })
            },
            upsertRow(row){
                const vm = this
                const paymentMethod = row.requestPayment.paymentMethod
                const creditCardTax = row.requestTax && row.requestTax.creditCardCompanyTax && !paymentMethod.onDelivery
                    ? parseFloat(row.requestTax.creditCardCompanyTax) 
                    : 0
                const zepplinTax = row.requestTax && row.requestTax.requestTax
                    ? parseFloat(row.requestTax.requestTax) 
                    : 0

                return {
                    id: row.id,
                    requestId: row.id,
                    columns: [
                        {
                            column: 'id',
                            text: row.code,
                            style: {
                                'justify-content': 'center'
                            }
                        },
                        {
                            column: 'name',
                            text: _.get(row, 'user.name', '---'),
                            showTitle: true
                        },
                        {
                            column: 'deliveryCompany',
                            text: _.get(row, 'deliveryCompany.name', '---')
                        },
                        {
                            column: 'deliveryTax',
                            text: row.deliveryTax ? utils.formatMoney(row.deliveryTax, 2,'R$ ','.',',') : '---'
                        },
                        {
                            column: 'deliveredDate',
                            text: row.requestTimeline ? moment(row.requestTimeline.dateFinished).local().format("DD/MM HH:mm") : '---',
                        },
                        {
                            column: 'paymentMethod',
                            text: _.get(paymentMethod, 'name', '---')
                        },
                        {
                            column: 'creditCardTax',
                            text: creditCardTax ? utils.formatMoney(creditCardTax, 2,'R$ ','.',',') : '---'
                        },
                        {
                            column: 'zepplinTax',
                            text: utils.formatMoney(zepplinTax, 2,'R$ ','.',','),
                        },
                        {
                            column: 'coupon',
                            text: row.coupon ? utils.formatMoney(row.coupon.amount, 2,'R$ ','.',',') : '---',
                        },
                        {
                            column: 'amount',
                            text: utils.formatMoney(parseFloat(row.totalPrice) + (row.coupon ? parseFloat(row.coupon.amount) : 0), 2,'R$ ','.',','),
                        },
                        {
                            column: 'subtotal',
                            text: utils.formatMoney(row.subtotal, 2,'R$ ','.',','),
                        },
                        {
                            column: 'actions',
                            html: true,
                            style: {
                                'justify-content': 'center'
                            }
                        }
                    ],
                    payload: {
                        requestId: row.id,
                        amount: row.totalPrice,
                        zepplinTax,
                        subtotal: row.subtotal,
                        creditCardTax,
                        coupon: row.coupon ? row.coupon : null
                    }
                }
            }
        },
        mounted(){
            this.search()
            /* this.$bus.$on("saveRequest", () => {
                this.onPageChange(this.currentPage)
            }) */
        }
    }
</script>

<style lang="scss">
    .page--crud {
        display: flex;
        width: 100%;
        justify-content: center;
        background-color: var(--bg-color--7);

        a.column-received {
            color: var(--font-color);
            &.active {
                color: var(--font-color--primary);
            }
            background-color: transparent;
        }

        a.edit-row {
            padding: 0 5px;
        }

        a.edit-row .colorizable {
            fill: var(--font-color)
        }

        a.edit-row:hover .colorizable {
            fill: var(--font-color--primary)
        }

        /* title */

        h3.title {
            font-size: 16px;
            text-transform: uppercase;
            color: var(--font-color--7)
        }

        /* filter */

        ul.filter-menu {
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: center;
            flex-shrink: 0;
            padding-bottom: 20px;
        }
        ul.filter-menu li {
            margin: 0 5px;
            position: relative;
        }
        ul.filter-menu >>> li.datetime-selector input {
            width: 100%;
            height: 100%;
            left: 0;
            top: 0;
            position: absolute;
            overflow: hidden;
            z-index: -1;
        }
        ul.filter-menu li a {
            height: 32px;
            border-radius: 20px;
            font-size: 12px;
            font-weight: 600;
            color: var(--font-color--7)
        }
        ul.filter-menu li a.right-padding {
            padding-right: 30px;
        }
        ul.filter-menu li a.clear-filter {
            position: absolute;
            top: 10px;
            right: 10px;
        }
        ul.filter-menu li a .primary {
            color: var(--font-color--primary);
            font-weight: 600;
        }
        ul.filter-menu li a .dot-separator.primary {
            background-color: var(--border-color--primary)
        }
        ul.filter-menu li a .secondary {
            color: var(--font-color--secondary);
            font-weight: 600;
        }
        ul.filter-menu li a .dot-separator.secondary {
            background-color: var(--border-color--secondary)
        }
        ul.filter-menu li a .terciary {
            color: var(--font-color--terciary);
            font-weight: 600;
        }
        ul.filter-menu li a .dot-separator.terciary {
            background-color: var(--border-color--terciary)
        }

        /* summary */

        .summary {
            display: flex;
            flex-direction: row;
            flex-shrink: 0;
            padding: 20px 20px;
            border-top: 1px solid var(--bg-color--8);

            .summary__item {
                display: flex;
                flex-direction: column;
                align-items: flex-end;
                padding: 0 20px;
                border-right: 1px solid var(--bg-color--8)
            }

            .summary__item.border-left {
                border-left: 1px solid var(--bg-color--8)
            }

            .summary__item:last-child {
                border-right: 0
            }
        }

        /* footer */

        div.footer {
            padding: 40px 0;
            display: flex;
            flex-shrink: 0;
            align-items: center;
            justify-content: center;
        }

        div.footer a {
            text-transform: uppercase;
        }

        div.footer span {
            font-weight: 600;
        }

        div.footer .left-side {
            display: flex;
            flex-direction: row;
            justify-content: center;
            align-items: center;
            padding-left: 20px;
        }

        div.footer .left-side > * {
            margin: 0 5px;
        }

        div.footer .right-side {
            display: flex;
            flex-direction: row;
            justify-content: center;
            align-items: center;
            padding-right: 20px;
        }

        div.footer .right-side .group {
            border: 1px solid var(--bg-color--9);
            display: flex;
            flex-direction: row;
            align-items: center;
            padding: 0 15px;
            border-radius: 10px;
            margin-right: 10px;
            height: 32px;
        }

        div.footer .right-side > a {
            height: 30px;
        }

        div.footer .right-side .group .dot-separator {
            margin: 0 10px;
        }

        div.footer .right-side .group span {
            margin-right: 10px;
            white-space: nowrap
        }

        div.footer .right-side > * {
            margin: 0 5px;
        }

        div.footer .right-side > *:last-child {
            margin: 0 0 0 5px;
        }
    }
    .page--crud > div {
        width: 96%;
        text-align: center;
        padding-top: 40px;
        display: flex;
        flex-direction: column;
    }
    .page--crud > div > h3 {
        padding-bottom: 30px;
    }

    .datetime-selector {
        margin-bottom: 0;
        border: 0;
        margin-top: 0;
        padding: 0;
        &:hover, &:active, &:focus {
            margin-bottom: 0;
            border: 0;
            margin-top: 0;
            padding: 0;
        }
    }

</style>